import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'
import React, { FC } from 'react'

import { NotificationOverviewModel } from '../../models/notifications.model'

const useStyles = makeStyles()(theme => ({
  disabledColumn: {
    color: theme.palette.grey.grey05,
  },
}))

interface ColumnProps {
  data: NotificationOverviewModel
  children?: React.ReactNode
}

/**
 * Column element for the message of the day table
 */
const Column: FC<ColumnProps> = ({ data, children }) => {
  const { classes } = useStyles()
  const isActive = data.active ?? true

  return <Box className={!isActive ? classes.disabledColumn : ''}>{children}</Box>
}

export default Column
